/* =Popups js
 ----------------------------------------------- */
(function ($) {

    // Supplier search popup
    const searchForm = $('.supplier-search-popup');
    $('.supplier-search-open').on('click', () => {
        searchForm.addClass('supplier-search-visible');
    });
    $('.supplier-search-close').on('click', () => {
        searchForm.addClass('supplier-search-fading');
        setTimeout(() => searchForm.removeClass('supplier-search-visible supplier-search-fading'), 600);
    });

    // Inline Popup
    const popup = $('.popup');
    if (popup.length > 0) {
        popup.magnificPopup({
            delegate: 'a',
            type: 'inline'
        });
    }

    // iFrame Popup
    const iframe = $('.iframe');
    if (iframe.length > 0) {
        iframe.magnificPopup({
            type: 'iframe'
        });
    }

    // Image popup
    const image = $('.image');
    if (image.length > 0) {
        image.magnificPopup({
            type: 'image'
        });
    }

    // Gallery popup
    const gallery = $('.gallery');
    if (gallery.length > 0) {
        gallery.magnificPopup({
            delegate: 'a[href*="wp-content/uploads"]',
            type: 'image',
            gallery: {
                enabled: true,
                preload: [0, 2],
                navigateByImgClick: true,
                arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
                tPrev: '<',
                tNext: '>',
                tCounter: '%curr% of %total%'
            }
        });
    }

})(jQuery);
